/**
 * Componente SearchBar
 * Wrapper para o Input.Search do Ant Design
 * Atualizado para usar Space.Compact ao invés de addonAfter (deprecated)
 */

import React, { useState, useEffect } from "react";
import { Input, Space, Button } from "antd";
import { Search } from "lucide-react";

const SearchBar = ({
  value,
  onChange,
  onSearch,
  onClear,
  placeholder = "Buscar...",
  className,
  size = "middle",
}) => {
  const [internalValue, setInternalValue] = useState(value ?? "");
  
  const sizeMap = {
    sm: "small",
    md: "middle",
    lg: "large",
  };

  // Sincronizar com value externo
  useEffect(() => {
    setInternalValue(value ?? "");
  }, [value]);

  // Handler para mudanças no input
  const handleChange = (e) => {
    const newValue = e?.target?.value ?? "";
    setInternalValue(newValue);
    onChange?.(newValue);
  };

  // Handler para busca (quando pressiona Enter ou clica no botão)
  const handleSearchClick = () => {
    const finalValue = internalValue;
    setInternalValue(finalValue);
    onChange?.(finalValue);
    onSearch?.(finalValue);
  };

  // Handler para Enter no input
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearchClick();
    }
  };

  // Handler para limpar
  const handleClear = () => {
    setInternalValue("");
    onChange?.("");
    onClear?.();
  };

  return (
    <Space.Compact style={{ width: "100%" }} className={className}>
      <Input
        value={internalValue}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
        allowClear={!!onClear}
        onClear={handleClear}
        size={sizeMap[size] || "middle"}
        style={{ width: "100%" }}
      />
      <Button
        type="primary"
        icon={<Search size={16} />}
        onClick={handleSearchClick}
        size={sizeMap[size] || "middle"}
      >
        Buscar
      </Button>
    </Space.Compact>
  );
};

export default SearchBar;
